import React from "react";
import ElectronicsTelecommunicationsHeader from "../components/Courses/ElectronicsTelecommunications/ElectronicsTelecommunicationsHeader";
import ElectronicsTelecommunicationsCareerSkills from "../components/Courses/ElectronicsTelecommunications/ElectronicsTelecommunicationsCareerSkills";
import ElectronicsTelecommunicationsProgramsCard from "../components/Courses/ElectronicsTelecommunications/ExploreProgramsElectronicsTelecommunications";
import ElectronicsTelecommunicationsAdmissionRequirements from "../components/Courses/ElectronicsTelecommunications/ElectronicsTelecommunicationsAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const ElectronicsTelecommunications = () => {
  return (
    <div>
      <Navbar />
      <ElectronicsTelecommunicationsHeader />
      <ElectronicsTelecommunicationsCareerSkills />
      <ElectronicsTelecommunicationsProgramsCard />
      <ElectronicsTelecommunicationsAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default ElectronicsTelecommunications;
